/* eslint-disable */
import React from "react";
import DTPic from "./HomePageImages/Image/direct_tax.png";
import IDTPic from "./HomePageImages/Image/indirect_tax.png";
import FinPic from "./HomePageImages/Image/finance.png";
import hthPic from "./HomePageImages/Image/hire_to_retire.png";
import ordertcPic from "./HomePageImages/Image/order_to_cash.png";
import processPic from "./HomePageImages/Image/ProcessExport.png";
import ProcPic from "./HomePageImages/Image/Procure_to_pay.png";
import qualityPic from "./HomePageImages/Image/process_excellence_quality.png";
import recoPic from "./HomePageImages/Image/record_to_report.png";
import TransPic from "./HomePageImages/Image/transition.png";
import GrpPic from "./HomePageImages/Image/user.png";
import SubNode from "./NodeCircle/subNode";
import styles from "./HomePageLayout.module.css";
import { useRoleAccess } from "./roleAccess";

const HomePageLayout = () => {
  const { hasCategory, hasSubCategory } = useRoleAccess();
  const { entity } = useRoleAccess();
  // console.log("test check sub cat -------------->", entity);
  return (
    <div
      className={`container-fluid d-flex flex-column justify-content-center align-items-center text-white ${styles.bg}`}
    >
      <div className="d-flex flex-row align-items-center justify-content-center flex-wrap w-100 mt-1">
        <div
          className="d-column align-items-center justify-content-center"
          style={{ marginRight: "7rem" }}
        >
          {/* Top Section */}
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ marginLeft: "8rem", position: "relative", top: "2px", right: "10px" }}
          >
            <div className="d-flex flex-row align-items-center gap-3 mb-2">
              {hasSubCategory("Direct Tax") ? (
                <div className={styles.animateFadeSlideIn}>
                  <SubNode
                    label="Direct Tax"
                    imgSrc={DTPic}
                    borderColor="#9769B6"
                  />
                </div>
              ) :
                (<div style={{ visibility: "hidden" }}>
                  <SubNode
                    label="Direct Tax"
                    imgSrc={DTPic}
                    borderColor="#9769B6"
                  />
                </div>

                )}
            </div>
          </div>

          {/* Center Node Line */}
          <div
            className="d-flex flex-row align-items-center justify-content-center"
            style={{
              position: "relative", top: "2px", right: "55px"
            }}
          >
            {hasSubCategory("Indirect Tax") ? (
              <div className={styles.animateFadeSlideIn} style={{
                position: "relative", top: "2px", right: "-85px"
              }}>
                <SubNode
                  label="Indirect Tax"
                  imgSrc={IDTPic}
                  borderColor="#9769B6"
                />
              </div>
            ) : (
              <div style={{ visibility: "hidden" }}>
                <SubNode
                  label="Indirect Tax"
                  imgSrc={IDTPic}
                  borderColor="#9769B6"
                />
              </div>

            )}
            {hasCategory("Knowledge") ? (
              <>
                <div className="mr-3" ></div>
                <div
                  className={`${styles.circle} ${styles.nodeCircle} d-flex flex-column align-items-center text-black`}
                  style={{
                    border: "thick solid #ffffffff",
                    background: "#9769B6",
                    width: "150px",
                    position: "relative", top: "2px", right: "-110px"
                  }}
                >
                  <span className={styles.mainSubNodeCustom}>Knowledge</span>
                </div>
              </>
            ) : (<>
              <div className="mr-3" style={{ visibility: "hidden" }}></div>
              <div
                style={{ visibility: "hidden" }}
              >
                <span className={styles.mainSubNodeCustom}>Knowledge</span>
              </div>
            </>

            )}
            <div className="m-2" ></div>

            {hasSubCategory("Legal") ? (
              // Newly Added For UI
              <div className={styles.animateFadeSlideIn} style={{
                position: "relative", top: "2px", right: "-125px"
              }}>
                <SubNode
                  label="Legal"
                  imgSrc={DTPic}
                  borderColor="#9769B6"
                  historypath={"/Legal-Page"}
                />
              </div>
            ) : (<div style={{ visibility: "hidden" }}>
              <SubNode
                label="Legal"
                imgSrc={DTPic}
                borderColor="#9769B6"
                historypath={"/Legal-Page"}
              />
            </div>
            )}
          </div>
        </div>
      </div>
      {/* Middle Layout */}
      <div className="d-flex flex-row align-items-center justify-content-center flex-wrap w-100 mt-1 " style={{ position: "relative", left: "10px" }}>
        {/* Left Stack */}
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column align-items-center">
            {hasSubCategory("R2R") ? (
              <div className={styles.animateSlideLeft}>
                <SubNode label="R2R" imgSrc={recoPic} borderColor="#00A9B9" historypath={"/Record-To-Report"} />
              </div>
            ) : (<div style={{ visibility: "hidden" }}>
              <SubNode label="R2R" imgSrc={recoPic} borderColor="#00A9B9" historypath={"/Record-To-Report"} />
            </div>

            )}
            <div className="m-1"></div>
            {hasSubCategory("P2P") ? (
              <div className={styles.animateSlideLeft}>
                <SubNode
                  label="P2P"
                  imgSrc={processPic}
                  borderColor="#00A9B9"
                />
              </div>
            ) : (<div style={{ visibility: "hidden" }}>
              <SubNode
                label="P2P"
                imgSrc={processPic}
                borderColor="#00A9B9"
              />
            </div>

            )}
          </div>
          <div className="d-flex flex-column align-items-center">
            {hasSubCategory("H2R") ? (
              <div className={styles.animateSlideLeft}>
                <SubNode label="H2R" imgSrc={hthPic} borderColor="#00A9B9" />
              </div>
            ) : (<div style={{ visibility: "hidden" }}>
              <SubNode label="H2R" imgSrc={hthPic} borderColor="#00A9B9" />
            </div>

            )}
            {hasCategory("Delivery") ? (
              <>
                <div className={styles.verticalLine}></div>
                <div
                  className={`${styles.subcircle} ${styles.nodeCircle} d-flex flex-column align-items-center text-black m-2`}
                  style={{
                    border: "thick solid #ffffffff",
                    background: "#00A9B9",
                    width: "150px",
                  }}
                >
                  <span className={styles.mainSubNodeCustom}>Delivery</span>
                </div>
                <div className={styles.verticalLine}></div>
              </>
            ) : (<>
              <div style={{ visibility: "hidden" }}></div>
              <div
                style={{ visibility: "hidden" }}
              >
                <span className={styles.mainSubNodeCustom}>Delivery</span>
              </div>
              <div className={styles.verticalLine}></div>
            </>

            )}
            {hasSubCategory("O2C") ? (
              <div className="m-1">
                <div className={styles.animateSlideLeft}>
                  <SubNode
                    label="O2C"
                    imgSrc={ordertcPic}
                    borderColor="#00A9B9"
                  />
                </div>
              </div>
            ) : (<div className="m-1" style={{ visibility: "hidden" }}>
              <div className={styles.animateSlideLeft}>
                <SubNode
                  label="O2C"
                  imgSrc={ordertcPic}
                  borderColor="#00A9B9"
                />
              </div>
            </div>

            )}
          </div>
        </div>

        {hasCategory("Delivery") ? (
          <div
            className={styles.horizontalLine}
            style={{ backgroundColor: "#00A9B9" }}
          ></div>
        ) : (<div
          className={styles.horizontalLine}
          style={{ visibility: "hidden" }}
        ></div>

        )}
        {/* Center Circle */}
        <div className="d-flex flex-column align-items-center">
          {hasCategory("Knowledge") ? (
            <div
              style={{
                backgroundColor: "#9769B6",
                width: "10px",
                height: "90px",
                marginBottom: "16px",
              }}
            ></div>
          ) : (<div
            style={{
              visibility: "hidden", backgroundColor: "#9769B6",
              width: "10px",
              height: "90px",
              marginBottom: "16px",
            }}
          ></div>

          )}
          <div
            className={`${styles.mainCircle} d-flex justify-content-center align-items-center`}
          >
            <div className="d-flex flex-column justify-content-center align-items-center text-center mb-5">
              <img
                src={GrpPic}
                style={{ maxWidth: "250px", height: "200px" }}
                alt="Group"
              />
              <span className={styles.fwBoldCustom + " text-black"}>
                {entity}
              </span>
            </div>
          </div>
        </div>
        {hasCategory("Enabling") ? (
          <div
            className={styles.horizontalLine}
            style={{ backgroundColor: "#FFB90B" }}
          ></div>
        ) : (<div
          className={styles.horizontalLine}
          style={{ visibility: "hidden" }}
        ></div>

        )}
        {/* Right Stack */}
        <div className="d-flex align-items-center">
          <div
            className={styles.horizontalLineRight}
            style={{ backgroundColor: "#FFB90B" }}
          ></div>

          <div className="d-flex flex-column align-items-center">
            {hasSubCategory("Talent") ? (
              <div className={styles.animateSlideRight}>
                <SubNode
                  label="Talent"
                  imgSrc={ProcPic}
                  borderColor="#FFB90B"
                />
              </div>
            ) : (<div className={styles.animateSlideRight} style={{ visibility: "hidden" }}>
              <SubNode
                label="Talent"
                imgSrc={ProcPic}
                borderColor="#FFB90B"
              />
            </div>

            )}
            {hasCategory("Enabling") ? (
              <>
                <div className={styles.verticalLine}></div>
                <div
                  className={`${styles.subcircle} ${styles.nodeCircle} d-flex flex-column align-items-center text-black`}
                  style={{
                    border: "thick solid #ffffffff",
                    background: "#FFB90B",
                    width: "150px",
                  }}
                >
                  <span className={styles.mainSubNodeCustom}>Enabling</span>
                </div>
              </>
            ) : (<>
              <div className={styles.verticalLine} style={{ visibility: "hidden" }}></div>
              <div
                className={`${styles.subcircle} ${styles.nodeCircle} d-flex flex-column align-items-center text-black`}
                style={{ visibility: "hidden" }}
              >
                <span className={styles.mainSubNodeCustom}>Enabling</span>
              </div>
            </>

            )}
            <div className={styles.verticalLine}></div>
            {hasSubCategory("Finance") ? (
              <div className={styles.animateSlideRight}>
                <SubNode
                  label="Finance"
                  imgSrc={FinPic}
                  borderColor="#FFB90B"
                />
              </div>
            ) : (<div className={styles.animateSlideRight} style={{ visibility: "hidden" }}>
              <SubNode
                label="Finance"
                imgSrc={FinPic}
                borderColor="#FFB90B"
              />
            </div>

            )}
          </div>
          <div className="d-flex flex-column">
            <div className={styles.rotatedLine3}></div>
            <div className={styles.rotatedLine4}></div>
          </div>
          <div className="d-flex flex-column align-items-center">
            {hasSubCategory("Transformation") ? (
              <div className="m-2">
                <div className={styles.animateSlideRight}>
                  <SubNode
                    label="Transformation"
                    imgSrc={qualityPic}
                    borderColor="#FFB90B"
                  />
                </div>
              </div>
            ) : (<div className="m-2" style={{ visibility: "hidden" }}>
              <div className={styles.animateSlideRight}>
                <SubNode
                  label="Transformation"
                  imgSrc={qualityPic}
                  borderColor="#FFB90B"
                />
              </div>
            </div>

            )}
            {hasSubCategory("Quality") ? (
              <div className={styles.animateSlideRight}>
                <SubNode
                  label="Quality"
                  imgSrc={qualityPic}
                  borderColor="#FFB90B"
                />
              </div>
            ) : (<div className={styles.animateSlideRight} style={{ visibility: "hidden" }}>
              <SubNode
                label="Quality"
                imgSrc={qualityPic}
                borderColor="#FFB90B"
              />
            </div>

            )}
            <div className="m-2"></div>
            {hasSubCategory("Transition") ? (
              <div className={styles.animateSlideRight}>
                <SubNode
                  label="Transition"
                  imgSrc={TransPic}
                  borderColor="#FFB90B"
                />
              </div>
            ) : (<div className={styles.animateSlideRight} style={{ visibility: "hidden" }}>
              <SubNode
                label="Transition"
                imgSrc={TransPic}
                borderColor="#FFB90B"
              />
            </div>

            )}
          </div>
        </div>
        {/* end right stack */}
      </div>
    </div>
  );
};

export default HomePageLayout;
